import { render } from "./DashboardTicketPromedio.vue?vue&type=template&id=85e935e8&scoped=true"
import script from "./DashboardTicketPromedio.vue?vue&type=script&lang=js"
export * from "./DashboardTicketPromedio.vue?vue&type=script&lang=js"

import "./DashboardTicketPromedio.vue?vue&type=style&index=0&id=85e935e8&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85e935e8"]])

export default __exports__